const Item = {

    // FIELDS
    "item": "Item",
    "name": "Name",
    "description": "Description",
    "category": "Category",
    "sub_category": "Sub Category",
    "subcategory": "Subcategory",
    "order_level": "Minimum Order Level",
    "status": "Status",
    "search": "Search",
    "parts_list": "Parts List",
    "assemble_parts": "Assemble Parts",
    "assemble_tools": "Assemble Tools",
    "parts": "Parts",
    "tools": "Tools",
    "quantity": "Quantity",
    "warranty": "Warranty",
    "min_quantity": "Min Quantity",
    "depreciation": "Depreciation",
    
    // PAGE HEADER
    "list_title": "Item",
    "filter_title": "Item Filter",
    "details_title": "Item Details",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_category": "Category",
    "table_sub_category": "Subcategory",
    
    // ERROR
    "error_name": "Enter Item Name",
    "error_description": "Enter Description",
    "error_category": "Select Category",
    "error_subcategory": "Select Sub Category",
    "error_order_level": "Enter Minimum Order Level",
    "error_status": "Select Status",
    "error_parts": "Select Parts",
    "error_quantity": "Enter Quantity",

}

export default Item;

